<template>
    <div class="nc-emoji-picker" @mousedown.prevent @click.stop>
        <div class="nc-emoji-picker__tabs">
            <button
                v-for="(cat, i) in categories"
                :key="i"
                type="button"
                class="nc-emoji-picker__tab"
                :class="{ 'is-active': activeIndex === i }"
                :title="cat.name"
                @mousedown.prevent
                @click="activeIndex = i"
            >{{ cat.icon }}</button>
        </div>
        <div class="nc-emoji-picker__grid">
            <button
                v-for="emoji in categories[activeIndex].emojis"
                :key="emoji"
                type="button"
                class="nc-emoji-picker__btn"
                :title="emoji"
                @mousedown.prevent
                @click="$emit('select', emoji)"
            >{{ emoji }}</button>
        </div>
    </div>
</template>

<script>
const CATEGORIES = [
    {
        icon: '😀',
        name: 'Смайлы',
        emojis: [
            '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😉',
            '😊','😇','🥰','😍','🤩','😘','😋','😜','🤪','😎',
            '😒','🙄','😔','😢','😭','😡','🤬','🤔','🤫','😴',
            '😷','🤢','🤮','🥳','🥺','😬','🤥','😌','😪','🫠',
        ],
    },
    {
        icon: '👋',
        name: 'Жесты',
        emojis: [
            '👋','🤚','✋','🖐️','👌','✌️','🤞','🤟','🤘','🤙',
            '👈','👉','👆','👇','☝️','👍','👎','✊','👊','👏',
            '🙌','🙏','💪','🤝','✍️','🤌','🫶','🤜','🤛','🖖',
        ],
    },
    {
        icon: '❤️',
        name: 'Символы',
        emojis: [
            '❤️','🧡','💛','💚','💙','💜','🖤','🤍','💔','💕',
            '💞','💓','💗','💖','💝','✨','⭐','🌟','💫','💥',
            '🔥','❄️','🌈','🎉','🎊','🎈','💯','🏆','🎯','✅',
            '⚡','🌀','🎵','🎶','❓','❗','💬','💭','🗯️','🔔',
        ],
    },
    {
        icon: '🐶',
        name: 'Природа',
        emojis: [
            '🐶','🐱','🐭','🐰','🦊','🐻','🐼','🐨','🐯','🦁',
            '🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐔','🐧','🦆',
            '🦋','🐢','🦎','🐍','🦖','🌸','🌺','🌻','🌹','🍀',
            '🌿','🌴','🍃','🌊','☁️','🌙','🌞','⚡','🌈','❄️',
        ],
    },
    {
        icon: '🍔',
        name: 'Еда',
        emojis: [
            '🍔','🍕','🍣','🍜','🍩','🍪','🍦','🎂','🍫','🍬',
            '🥤','☕','🍺','🥂','🍷','🧁','🍓','🍇','🥑','🍟',
            '🌮','🍱','🥗','🍝','🥞','🍿','🥜','🫐','🍑','🍊',
        ],
    },
    {
        icon: '🚗',
        name: 'Прочее',
        emojis: [
            '🚗','✈️','🚀','🌍','📱','💻','📸','🎵','🎮','🔑',
            '💡','🔔','💎','🎁','⏰','📍','🛒','📚','✏️','💼',
            '🎬','🎤','🎧','🔍','🏠','🏖️','⛄','🎭','🎪','🎠',
        ],
    },
]

export default {
    name: 'NewChatEmojiPicker',
    data() {
        return {
            activeIndex: 0,
            categories: CATEGORIES,
        }
    },
}
</script>

<style lang="scss">
@import '../../../../../../gulp-src/app/scss/_variables';
@import '../../../../../../gulp-src/app/scss/_mixins';

.nc-emoji-picker {
    border: 1px solid $global-light-gray;
    border-radius: 8px;
    margin-bottom: 6px;
    background: $global-white;
    overflow: hidden;
    user-select: none;

    &__tabs {
        display: flex;
        gap: 2px;
        padding: 4px 6px;
        border-bottom: 1px solid $global-light-gray;
        background: $global-white-f6;
        overflow-x: auto;
        @include scrollbar($thumb-color: $global-dark-3a, $track-color: $global-light-gray);
    }

    &__tab {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 28px;
        border: none;
        border-radius: 6px;
        background: none;
        cursor: pointer;
        font-size: 16px;
        line-height: 1;
        padding: 0;
        transition: background 0.12s ease;

        &:hover {
            background: $global-light-gray;
        }

        &.is-active {
            background: $global-dark-3a;
        }
    }

    &__grid {
        display: grid;
        grid-template-columns: repeat(8, 1fr);
        gap: 2px;
        padding: 6px;
        max-height: 176px;
        overflow-y: auto;
        @include scrollbar($thumb-color: $global-dark-3a, $track-color: $global-light-gray);
    }

    &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        border: none;
        border-radius: 4px;
        background: none;
        cursor: pointer;
        font-size: 18px;
        line-height: 1;
        padding: 0;
        transition: background 0.12s ease;

        &:hover {
            background: $global-white-f6;
        }

        &:active {
            transform: scale(1.15);
        }
    }
}
</style>
